export const nav = () => ({
    display: 'grid',
    gridTemplateColumns: '40px 1fr',
    gridColumnGap: '16px',
    alignItems: 'center',
    padding: '24px 30px 16px',
});
